// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Snackbar_wrapper__2_ShA","closeButton":"Snackbar_closeButton__1ok-N"};